import { Image } from 'antd';

import { LoadingImg } from './picturePerview';

const sameImgMap = {
  ti: 'https://static.szlcsc.com/ecp/assets/newWeb/so/lcdh.svg',
  waldom: 'https://static.szlcsc.com/ecp/assets/newWeb/so/lcdh.svg',
  rochester: 'https://static.szlcsc.com/ecp/assets/newWeb/so/lcdh.svg',
  te: 'https://static.szlcsc.com/ecp/assets/newWeb/so/lcdh.svg',
  ti_ovs: 'https://static.szlcsc.com/ecp/assets/web/common/images/productItem/ti_new.png',
  burklin: 'https://static.szlcsc.com/ecp/assets/web/common/images/productItem/burklin.png',
  digikey: 'https://static.szlcsc.com/ecp/assets/web/common/images/productItem/digikey.jpg',
  arrow: 'A',
  element: 'E',
  element14_uk: 'E',
  future: 'https://static.szlcsc.com/ecp/assets/web/page/so/so/images/ti.png',
  verical: 'V',
  avnet_us: 'https://static.szlcsc.com/ecp/assets/web/common/images/productItem/avnet.jpg',
  avnet_eur: 'https://static.szlcsc.com/ecp/assets/web/common/images/productItem/avnet.jpg',
  avnet_asia: 'https://static.szlcsc.com/ecp/assets/web/common/images/productItem/avnet.jpg',
  onlinecomponents: 'https://static.szlcsc.com/ecp/assets/web/common/images/productItem/OLC.jpg',
  rscomponents: 'https://static.szlcsc.com/ecp/assets/web/common/images/productItem/RS.jpg',
  tme: 'https://static.szlcsc.com/ecp/assets/web/page/so/so/images/ti.png',
  corestaff: 'https://static.szlcsc.com/ecp/assets/web/common/images/productItem/corestaff.jpg',
  tti: 'https://static.szlcsc.com/ecp/assets/web/common/images/productItem/tti.jpg',
  rutronik: 'https://static.szlcsc.com/ecp/assets/web/common/images/productItem/rutronik.jpg',
  questcomp: 'https://static.szlcsc.com/ecp/assets/web/common/images/productItem/questcomp.jpg',
  powell: 'https://static.szlcsc.com/ecp/assets/web/common/images/productItem/powell.jpg',
  sager: 'https://static.szlcsc.com/ecp/assets/web/common/images/productItem/sager.jpg',
  chip1stop: 'https://static.szlcsc.com/ecp/assets/web/common/images/productItem/chip1stop.jpg',
  heilind: 'https://static.szlcsc.com/ecp/assets/web/common/images/productItem/heilind.jpg',
  mouser: 'https://static.szlcsc.com/ecp/assets/web/common/images/productItem/mouser.jpg',
};

export default function OverseasPicture(props) {
  const { productVO } = props;

  let image = sameImgMap[productVO?.provider];
  // 供应商G14102-香港-Texas Instruments图片使用TI logo
  if (productVO?.vendorCode === 'G14102') {
    image = sameImgMap['ti_ovs'];
  }

  if (image?.startsWith('https://') || productVO?.selfBreviaryImageUrl) {
    return (
      <Image
        fallback={'https://static.szlcsc.com/ecp/assets/web/static/images/default_pic.gif'}
        src={productVO?.selfBreviaryImageUrl || image}
        width={105}
        height={105}
        preview={false}
        loading="lazy"
        placeholder={<LoadingImg></LoadingImg>}
        style={{ borderRadius: '4px' }}
        alt={'相似图'}
      />
    );
  } else {
    return (
      <div className="size-[105px] rounded-[4px] bg-[#F5F6F9] text-center text-[25px] font-bold leading-[105px] text-[#3d3d3d]">
        {image}
      </div>
    );
  }
}
